import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import carInsuranceService from "../../../../api/CarInsurance/CarInsuranceService";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default class CreateCarInsurance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      carInsurance: {
        id: null,
        description: null,
        ar_description: null,
        email: null,
      },
    };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  onCreateChange = (name, value) => {
    let carInsurance = this.state.carInsurance;
    carInsurance[name] = value;
    this.setState({ carInsurance });
  };

  onCreateEmailChange = (e) => {
    let carInsurance = this.state.carInsurance;
    carInsurance.email = e.target.value;
    this.setState({ carInsurance });
  };

  onButtonClick = () => {
    carInsuranceService.addInsurance({
      description: this.state.carInsurance.description,
      ar_description: this.state.carInsurance.ar_description,
    });
    toast.success(`Car Insurance Created Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.setState({
      category: { id: null, description: null, ar_description: null },
    });
  };

  render() {
    return (
      <>
        <h5 className="m-0">Create Car Insurance</h5>
        <Row form>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Description</label>
              {/* <FormControl
                autoFocus
                type="text"
                name="description"
                id="description"
                onChange={this.onCreateChange.bind(this)}
              /> */}
              <CKEditor
                editor={ClassicEditor}
                data="Please type here the car insurance description"
                onReady={(editor) => {
                  // You can store the "editor" and use when it is needed.
                  console.log("Editor is ready to use!", editor);
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  //console.log( { event, editor, data } );
                  this.onCreateChange("description", data);
                }}
                onBlur={(event, editor) => {
                  console.log("Blur.", editor);
                }}
                onFocus={(event, editor) => {
                  console.log("Focus.", editor);
                }}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Arabic Description</label>
              {/* <FormControl
                autoFocus
                type="text"
                name="description"
                id="description"
                onChange={this.onCreateChange.bind(this)}
              /> */}
              <CKEditor
                editor={ClassicEditor}
                data="Please type here the car insurance description"
                onReady={(editor) => {
                  // You can store the "editor" and use when it is needed.
                  console.log("Editor is ready to use!", editor);
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  //console.log( { event, editor, data } );
                  this.onCreateChange("ar_description", data);
                }}
                onBlur={(event, editor) => {
                  console.log("Blur.", editor);
                }}
                onFocus={(event, editor) => {
                  console.log("Focus.", editor);
                }}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Email</label>
              <FormControl
                autoFocus
                type="email"
                name="email"
                id="email"
                onChange={this.onCreateEmailChange.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col
            md="6"
            className="form-group pt-2 align-self-center"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={this.onButtonClick.bind(this)}
            >
              Create
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
